import create from "zustand";

export const authSlice = create((set) => ({
  user: null,
  setUser: (user: any) => set((_) => ({ user })),
}));
